const LoadingMapComponent = () => {
  return <div>Loading map...</div>; // Updated loading message
};

export default LoadingMapComponent;
